import React, { Component } from "react";

// @ts-ignore
import cn from "classnames";
import Throbber from "../../../components/Throbber";
import Markdown from "../../../components/Markdown";
import WorkflowStepAlert from "./WorkflowStepAlert";
import WorkflowActions from "./WorkflowActions";
import stepShouldSwitchAutomatically from "../../../../redux/modules/workflow/stepShouldSwitchAutomatically";
import {
  workflowStepCN,
  workflowStepFailedCN,
  workflowStepFailedIdLabelCN,
  workflowStepBottomAlertCN,
  workflowStepContentCN,
  workflowStepIdLabelCN,
  workflowStepContentTitleCN,
  workflowStepContentDescriptionCN,
} from "./styles";

import type {
  WorkflowStep,
  WorkflowAction,
} from "../../../../redux/modules/workflow/reducer";
import AlertError from "../AlertError";
import RollbackButton from "./RollbackButton";

interface WorkflowStepFailedProps {
  step: WorkflowStep;
  isRollbackAvailable: boolean;
  onRollback: () => void;
  onSubmit: (actions: WorkflowAction[]) => void;
}

export default class WorkflowStepFailed extends Component<WorkflowStepFailedProps> {
  render() {
    const { id, title, descriptionMd, pending } = this.props.step;
    const { onSubmit, isRollbackAvailable } = this.props;

    return (
      <div
        className={cn(workflowStepCN, workflowStepFailedCN)}
        id={`workflow-step-${id}`}
      >
        <div className={cn(workflowStepFailedIdLabelCN, workflowStepIdLabelCN)}>
          {pending ? <Throbber /> : id}
        </div>
        <div className={workflowStepContentCN}>
          {isRollbackAvailable ? (
            <RollbackButton onClick={() => this.props.onRollback()} />
          ) : null}
          <div className={workflowStepContentTitleCN}>{title}</div>
          <div className={workflowStepContentDescriptionCN}>
            <Markdown text={descriptionMd} />
          </div>
          {this.renderStepError()}
          <WorkflowActions step={this.props.step} onSubmit={onSubmit} />
        </div>
        {this.renderBottomAlert()}
      </div>
    );
  }

  renderStepError() {
    const { error } = this.props.step;
    if (!error) {
      return null;
    }
    return <AlertError header={"Something went wrong"} message={error} />;
  }

  renderBottomAlert() {
    if (!stepShouldSwitchAutomatically(this.props.step)) {
      return null;
    }

    return (
      <div className={workflowStepBottomAlertCN}>
        <WorkflowStepAlert
          header={"Do not close the browser until the upload is complete"}
          message={"You will be automatically directed to the next step."}
        />
      </div>
    );
  }
}
